import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, registerLazyOrchestrator, type LazyComponent, } from "owa-bundling";
import { type CopilotDabProps } from "./components/CopilotDab.Props";
import onRemoveProjection from "owa-popout-v2/lib/actions/onRemoveProjection";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CopilotDab" */ "./lazyIndex"), { name: "CopilotDab" });

// Clean up per-window gleam / DabInputBox state when a popout projection closes,
// instead of driving the cleanup mutator from a React unmount effect.
registerLazyOrchestrator(onRemoveProjection, lazyModule, m => m.removeDabGleamStateOrchestrator);

// TODO: add placeholder?
export const LazyCopilotDab: LazyComponent<CopilotDabProps, undefined, null> = createLazyComponent(lazyModule, m => m.CopilotDab);

export { MAIN_BUTTON_ID } from "./constants/mainButtonId";
